import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { LinearProgress } from "@mui/material";

const SERVER_OPTIONS = {
  useCursorPagination: false,
};

// const { useQuery, ...data } = createFakeServer({}, SERVER_OPTIONS);

export default function ServerPaginationGrid({
  sx = {},
  name = "QUERY_NAME",
  columns = [],
  count = 0,
  getDataByPage = async () => alert("Provide getDataByPage function;"),
  // getDataByPage = async () => alert("Provide getDataByPage function;"),
  getRefetchFn = () => {},
  dependecies = {},
  depStr = "",
}) {
  // const [paginationModel, setPaginationModel] = React.useState({
  //   page: 0,
  //   pageSize: 10,
  // });

  // const { isLoading, rows, pageInfo } = useQuery(paginationModel);

  // let isLoading = false;
  let pageInfo = {
    totalRowCount: count,
  };
  // Some API clients return undefined while loading
  // Following lines are here to prevent `rowCount` from being undefined during the loading
  const [rowCount, setRowCount] = React.useState(count);
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [size, setSize] = React.useState(25);
  const [range, setRange] = React.useState({
    from: page * size,
    to: (page + 1) * size - 1,
  });

  const { data, isLoading, refetch } = useQuery(
    [name, page, range.from + "-" + range.to, depStr],
    () => getDataByPage(range),
    {
      onSuccess: (res) => {
        console.log(9999, res);
      },
    }
  );
  getRefetchFn(refetch);

  useEffect(() => {
    setRange({ from: page * size, to: (page + 1) * size - 1 });
    refetch();
  }, [page, size]);
  // console.clear();
  // console.log({ depStr });
  // console.log({ __data: data });

  // useEffect(

  // )

  // console.log({range, data, page})
  // console.log({size})

  // useEffect(
  //   () => {

  //    const fetchData =  async () => {
  //       setRowCount(count)
  //       let __rows = await getDataByPage({ from: 0, to: 12 })
  //       console.log({__rows})
  //     }
  //     fetchData()
  //     return () => {}
  //   }

  //   ,[page,rowCount,size]
  // )
  // React.useEffect(() => {
  //   setRowCount((prevRowCountState) =>
  //     pageInfo?.totalRowCount !== undefined
  //       ? pageInfo?.totalRowCount
  //       : prevRowCountState,
  //   );
  // }, [pageInfo?.totalRowCount, setRowCount]);

  useEffect(() => console.log("page changed"), [page, rowCount, size]);
  const dataGridStyles = {
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none",
    },
    border: "1px solid #EAECF0 !important",
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    fontFamily: "Inter-Medium",
    borderRadius: "8px",
    '& div[data-colindex="1"]': {
      color: "#101828",
      fontWeight: "500",
    },
    "& .MuiDataGrid-virtualScrollerRenderZone": {
      "& .MuiDataGrid-row": {
        borderBottom: "1px solid #EAECF0",
        background: "#FFFFFF",
        /* Shadow/xl */

        // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        borderRadius: "1rem",

        //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
        //   backgroundColor: "#FFFFFF",
      },
      "& .MuiDataGrid-row.Mui-selected:hover": {
        borderBottom: "1px solid #EAECF0",
        backgroundColor: "#FFFFFF",
        // "&:nth-of-type(2n+1)": {
        //   backgroundColor: "rgba(249, 250, 251, 1)",
        // },
      },
    },
    "& .MuiDataGrid-iconSeparator ": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeader:hover": {
      "& .MuiDataGrid-menuIcon": {
        visibility: "hidden",
      },
    },

    "&  .MuiDataGrid-columnHeaders": {
      background: "#F9FAFB",
      /* Gray/200 */
      border: "1px solid #EAECF0",
      /* Shadow/xl */
      // boxShadow:
      //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      // borderRadius: "8px",

      marginBottom: "1rem",
      borderBottom: "6px solid #EAECF0",
    },
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-checkboxInput": {
      "& svg": {
        width: "2rem",
        height: "2rem",
        background: "#FFFFFF",
      },
    },
    // "& .MuiTablePagination-displayedRows": {
    //   display: "none",
    // },
    "& .MuiDataGrid-footerContainer": {
      "& .MuiTablePagination-displayedRows ": {
        // display: "none",
      },
      "& .MuiDataGrid-selectedRowCount": {
        visibility: "hidden ",
      },
    },
    "&  [title='Sort']": {
      //visibility:"hidden",
      display: "none",
      cursor: "none",
    },
    "& [title='Go to previous page']": {
      borderRadius: "0",
      border: "1px solid #EAECF0",
      borderRadius: "0.8rem",
      marginRight: "0.5rem",
    },
    "& [title='Go to next page']": {
      borderRadius: "0",
      border: "1px solid #EAECF0",
      borderRadius: "0.8rem",
      marginRight: "0.5rem",
    },
    "& [title='Go to previous page']:after": {
      content: "'Previous'",
      marginLeft: "1rem",
    },
    "& [title='Go to next page']:before": {
      content: "'Next'",
      marginRight: "1rem",
    },
    "& .MuiDataGrid-columnHeader": {
      padding: "0 2rem",

      "&:focus": {
        outline: "none",
      },
    },
    "&  .MuiDataGrid-row ": {
      maxHeight: "72px !important",
      minHeight: "72px !important",
    },
    "& .MuiDataGrid-cell": {
      padding: "0 2rem",
      minHeight: "72px !important",
      maxHeight: "72px !important",
      "&:focus": {
        outline: "none",
      },
    },
    "& .MuiButtonBase-root": {
      fontSize: "1.6rem",
    },
    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
  };
  return (
    <div style={{ width: "100%", fontSize: "1rem" }}>
      <DataGrid
        slots={{
          loadingOverlay: LinearProgress,
        }}
        loading={isLoading}
        sx={{
          "& *": {
            fontSize: "1.6rem",
          },

          ...sx,
          ...dataGridStyles,
        }}
        rows={data || []}
        columns={columns}
        rowCount={rowCount}
        // pageSizeOptions={[5,10,15]}
        pageSize={size}
        onPageSizeChange={(size) => setSize(size)}
        // paginationModel={paginationModel}
        page={page}
        onPageChange={(page) => {
          setPage(page);
          // setRange({from : page * 100, to : page  * 100})
          // setRange({from : range.to + 1, to : range.to + size})
          console.log(page);
          return page;
        }}
        paginationMode="server"
        // onPaginationModelChange={setPaginationModel}
        initialState={{ pageSize: size }}
      />
    </div>
  );
}
